var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWixLogo = function SvgWixLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wix-logo_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 85,
    height: 40,
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".wix-logo_svg__st0{fill:#172e3e}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wix-logo_svg__XMLID_170_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wix-logo_svg__XMLID_171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "wix-logo_svg__XMLID_172_",
    className: "wix-logo_svg__st0",
    d: "M46.3 6.2c-1.4.7-2 2-2 5.5 0 0 .7-.7 1.8-1.1.8-.3 1.4-.7 1.8-1 1.2-.9 1.4-2 1.4-3.9 0-.1-1.9-.1-3 .5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wix-logo_svg__XMLID_173_",
    className: "wix-logo_svg__st0",
    d: "M37.8 7c-1.2 1-1.5 2.7-1.5 2.7l-3.9 14.9-3.2-12.2c-.3-1.3-.9-2.9-1.8-4C26.3 7 24 6.9 23.8 6.9c-.2 0-2.6.1-3.7 1.5-.9 1.1-1.5 2.7-1.8 4l-3.2 12.2-3.8-15S11 8 9.8 6.9C7.9 5.3 5.1 5.7 5.1 5.7l7.4 27.9s2.4.2 3.7-.4c1.6-.8 2.4-1.4 3.3-5.2.9-3.4 3.3-13.3 3.5-14 .1-.3.3-1.2.9-1.2.6 0 .8.8.9 1.2.2.7 2.6 10.6 3.5 14 1 3.8 1.7 4.4 3.3 5.2 1.2.6 3.7.4 3.7.4l7.4-27.9c-.2 0-3-.4-4.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wix-logo_svg__XMLID_174_",
    className: "wix-logo_svg__st0",
    d: "M49.3 10.2s-.5.7-1.5 1.3c-.7.4-1.3.6-2 1-1.2.6-1.5 1.2-1.5 2.1v19s1.9.2 3.1-.4c1.6-.8 1.9-1.6 1.9-5v-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wix-logo_svg__XMLID_175_",
    className: "wix-logo_svg__st0",
    d: "m67.7 19.7 9.4-13.9s-4-.7-5.9 1.1c-1.3 1.1-2.7 3.2-2.7 3.2l-3.4 5c-.2.3-.4.5-.7.5s-.6-.3-.7-.5l-3.4-5s-1.4-2-2.7-3.2c-2-1.8-5.9-1.1-5.9-1.1L61 19.7l-9.3 13.9s4.1.5 6.1-1.3c1.3-1.1 2.5-3 2.5-3l3.4-5c.2-.3.4-.5.7-.5s.6.3.7.5l3.4 5s1.3 1.9 2.5 3c2 1.8 6 1.3 6 1.3l-9.3-13.9z"
  })))));
};
export default SvgWixLogo;